import { MAX_INPUT_LENGTH } from '@/src/utils/srp/aiRecommendation/metrics'
import { Box, TextField, Typography } from '@mui/material'
import AnimatedPlaceholder from './AnimatedPlaceholder'

interface TextModeTabProps {
    value: string
    onChange: (value: string) => void
}

const TextModeTab = ({ value, onChange }: TextModeTabProps) => {
    const isEmpty = !value
    const charCount = value.length
    const isAtLimit = charCount >= MAX_INPUT_LENGTH

    return (
        <Box p={1}>
            <Box sx={{ position: 'relative' }}>
                <TextField
                    fullWidth
                    multiline
                    minRows={4}
                    maxRows={8}
                    value={value}
                    onChange={e => {
                        const next = e.target.value
                        if (next.length <= MAX_INPUT_LENGTH) onChange(next)
                    }}
                    variant="outlined"
                    size="small"
                    inputProps={{ maxLength: MAX_INPUT_LENGTH }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 1,
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: 'divider',
                                borderWidth: 1,
                            },
                        },
                    }}
                />
                {isEmpty && <AnimatedPlaceholder />}
            </Box>
            <Typography
                variant="caption"
                sx={{
                    display: 'block',
                    textAlign: 'right',
                    mt: 0.5,
                    color: isAtLimit ? 'error.main' : 'text.disabled',
                }}
            >
                {charCount}/{MAX_INPUT_LENGTH}
            </Typography>
        </Box>
    )
}

export default TextModeTab
